module.exports = __webpack_public_path__ + "static/media/top.f340ad9f.jpg";